/**************************************************
 * Nombre:       Home_Portada
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import {useResponsive} from "../../../Modulo_responsive/Hooks/useResponsive";
import {useContext, useEffect, useState} from "react";
import {contexApp} from "../../../App";
import {useNavigate} from "react-router";
import {Splide, SplideSlide} from "@splidejs/react-splide";
import '@splidejs/react-splide'
import Tarjeta_Banner_Portada from "../../Tarjetas/Tarjeta_Banner_Portada";


const Home_Portada = () => {
    const {sCell, masSM, esSafari, sTab} = useResponsive()
    const cData = useContext(contexApp)
    const navigate = useNavigate();
    const [anuncios, setAnuncios] = useState([])

    useEffect(() => {

        if (cData.anuncios) {
            setAnuncios(cData.anuncios)
        }

    }, [cData])
    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{
                background: 'linear-gradient(180deg, #000 0%, rgba(0, 0, 0, 0.00) 59.46%)'
            }}
        >

            {anuncios.length > 0 &&
                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <Splide
                        aria-label="My Favorite Images" style={{width: '100%'}}
                        options={{
                            autoplay: true,
                            speed: 5000,
                            rewind: true,
                            perPage: 1,
                            arrows: false,
                            pagination: true,
                            width: '100%',
                            drag: 'false',
                            interval: 5000,
                            noDrag: true,
                            type: 'fade',


                        }}
                    >

                        {anuncios.map((it, index) => {
                            return (
                                <SplideSlide key={`qed${index}`}>
                                    <Tarjeta_Banner_Portada item={it}/>
                                </SplideSlide>
                            )
                        })}


                    </Splide>
                </Grid>
            }

        </Grid>

    )

}
export default Home_Portada

const items = [1, 2, 3]